import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

// import NotificationsIcon from "@material-ui/icons/Notifications";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faNetworkWired,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@material-ui/core/styles";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Avatar, Grid, IconButton, TextField } from "@material-ui/core";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import { FirebaseContext } from "../Firebase";
import apnaqLogo from "../Images/apnaq.svg";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  textFieldRoot: {
    padding: "5px",
    boxShadow:
      "3px 3px 3px 0 rgba(255, 255, 255, 0.10),-3px -3px 3px 0 rgba(0, 0, 0, 0.15)",
    width: "20vw",
  },
  textFieldInput: {
    color: "#5A9BB7",
    paddingLeft: "10px",
    fontWeight: "300",
    marginRight: "10px",
    fontFamily: "'Poppins', sansSerif",
  },
  notificationsIcon: {
    marginRight: "15px",
    marginLeft: "15px",
  },

  appBar: {
    backgroundColor: "#172941",
    boxShadow: "none",

    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#172941",
    color: "#fff",
    boxShadow:
      "12px 9px 16px 0 rgba(0, 0, 0, 0.15), -3px -3px 8px 0 rgba(255, 255, 255, 0.10)",
  },
  icon: {
    color: "#fff",
    marginLeft: "1vw",
  },
  toolbar: theme.mixins.toolbar,

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#172941",
    marginLeft: -drawerWidth,
    fontFamily: "'Poppins', sansSerif",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end",
  },
}));

export default function PermanentDrawerLeft(props) {
  const classes = useStyles();
  const history = useHistory();
  const [User, setUser] = useState({});
  const [open, setOpen] = React.useState(true);
  const theme = useTheme();
  const handleDrawerOpen = () => {
    // console.log("index is ", props.index);
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(() => {
    // console.log(window.location.pathname);
    if (window.location.pathname === "/dashboard") {
      setSelectedTab(0);
    } else if (window.location.pathname === "/myQueues") {
      setSelectedTab(1);
    } else {
      setSelectedTab(2);
    }
  });

  useEffect(() => {
    // console.log("idtoken is", localStorage.getItem("idToken"));
    Axios.post(
      "https://asia-east2-apnaq-prod.cloudfunctions.net/getUserDataApi",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("idToken"),
        },
      }
    ).then((res) => {
      // console.log("user ", res.data);
      if (res.data.success) {
        // console.log("userdetails success");
        setUser(res.data.user);
      } else {
        localStorage.removeItem("idToken")
        history.replace("/");
      }
    });
  }, []);

  return (
    <FirebaseContext.Consumer>
      {(fire) => (
        <div className={classes.root}>
          <CssBaseline />
          <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar>
              <Typography variant="h6" noWrap>
                <IconButton
                  onClick={handleDrawerOpen}
                  className={clsx(classes.menuButton, open && classes.hide)}
                >
                  <MenuIcon style={{ color: "#fff" }} />
                </IconButton>
              </Typography>
              <img
                src={apnaqLogo}
                alt="logo"
                style={{
                  height: "70px",
                  width: "170px",
                  display: open ? "none" : "block",
                }}
              />
              <Grid container direction="row-reverse" alignItems="center">
                {Object.keys(User).length > 0 ? (
                  User.name ? (
                    <Typography
                      style={{
                        fontFamily: "'Poppins', sansSerif",
                        fontWeight: "500",
                        color: "#fff",
                        marginLeft: ".3vw",
                        marginRight: "4vw",
                      }}
                    >
                      {User.name}
                    </Typography>
                  ) : null
                ) : null}
                <Avatar alt={User.name} src={User.photoUrl} style={{marginLeft: "4vw",}}/>
                {/* <NotificationsIcon className={classes.notificationsIcon} /> */}
                <TextField
                  placeholder="Search"
                  classes={{
                    root: classes.textFieldRoot,
                    // input:classes.textFieldInput
                  }}
                  InputProps={{
                    className: classes.textFieldInput,
                    endAdornment: <SearchIcon />,
                    disableUnderline: true,
                  }}
                />
              </Grid>
            </Toolbar>
          </AppBar>
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            <div className={classes.drawerHeader}>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === "ltr" ? (
                  <ChevronLeftIcon style={{ color: "#fff" }} />
                ) : (
                  <ChevronRightIcon />
                )}
              </IconButton>
            </div>
            <Grid
              container
              alignContent="center"
              justify="center"
              className={classes.toolbar}
            >
              <img
                src={apnaqLogo}
                alt="logo"
                style={{ height: "100px", width: "170px" }}
              />
            </Grid>
            <List>
              {selectedTab === 0 ? (
                <ListItem
                  style={{
                    backgroundColor: "#334358",
                    fontFamily: "'Poppins', sansSerif",
                    color: "#22FCA8",
                  }}
                  button
                  key="Facility"
                  onClick={() => {
                    setSelectedTab(0);
                    history.push("/dashboard");
                  }}
                >
                  <ListItemIcon>
                    {" "}
                    <FontAwesomeIcon
                      icon={faNetworkWired}
                      className={classes.icon}
                      style={{ color: "#22FCA8" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Facility" />
                </ListItem>
              ) : (
                <ListItem
                  style={{
                    backgroundColor: "#172941",
                    fontFamily: "'Poppins', sansSerif",
                    color: "#5A9BB7",
                  }}
                  button
                  key="Facility"
                  onClick={() => {
                    setSelectedTab(0);
                    history.push("/dashboard");
                  }}
                >
                  <ListItemIcon>
                    {" "}
                    <FontAwesomeIcon
                      icon={faNetworkWired}
                      className={classes.icon}
                      style={{ color: "#5A9BB7" }}
                    />
                  </ListItemIcon>
                  <ListItemText primary="Facility" />
                </ListItem>
              )}

              <ListItem
                style={{
                  backgroundColor: selectedTab === 1 ? "#334358" : "#172941",
                  fontFamily: "'Poppins', sansSerif",
                  color: selectedTab === 1 ? "#22FCA8" : "#5A9BB7",
                }}
                button
                key="My Queues"
                onClick={() => {
                  setSelectedTab(1);
                  history.push("/myQueues");
                }}
              >
                <ListItemIcon>
                  {" "}
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className={classes.icon}
                    style={{ color: selectedTab === 1 ? "#22FCA8" : "#5A9BB7" }}
                  />
                </ListItemIcon>
                <ListItemText primary="My Queue" />
              </ListItem>
              <ListItem
                style={{
                  backgroundColor: selectedTab === 2 ? "#334358" : "#172941",
                  fontFamily: "'Poppins', sansSerif",
                  color: selectedTab === 2 ? "#22FCA8" : "#5A9BB7",
                }}
                button
                key="Users"
                onClick={() => setSelectedTab(2)}
              >
                <ListItemIcon>
                  {" "}
                  <FontAwesomeIcon
                    icon={faUserAlt}
                    className={classes.icon}
                    style={{ color: selectedTab === 2 ? "#22FCA8" : "#5A9BB7" }}
                  />
                </ListItemIcon>
                <ListItemText primary="Users" />
              </ListItem>
            </List>
          </Drawer>
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            <div className={classes.toolbar} />
            {props.children}
          </main>
        </div>
      )}
    </FirebaseContext.Consumer>
  );
}
